import { FLOW_STATES } from '@/modules/Flow/constants'

export const flowStates = [
  {
    name: FLOW_STATES.NEW,
    entryPointViewName: 'claim-landing'
  },
  {
    name: FLOW_STATES.CLAIM_DETAILS,
    entryPointViewName: 'claim-details'
  },
  {
    name: FLOW_STATES.PROCESSED,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.PROCESSED_OK,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.PROCESSED_KO,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.PROCESSED_ERROR,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.WAITING_ROOM,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.DAMAGES,
    entryPointViewName: 'damages-view'
  },
  {
    name: FLOW_STATES.GAG_DETAILS,
    entryPointViewName: 'damage-validation'
  },
  {
    name: FLOW_STATES.BILLMA,
    entryPointViewName: 'handle-document'
  },
  {
    name: FLOW_STATES.REN_DETAILS,
    entryPointViewName: 'add-appointment'
  },
  {
    name: FLOW_STATES.SMART,
    entryPointViewName: 'fnol-flow'
  },
  {
    name: FLOW_STATES.COMPENSATION_TYPE,
    entryPointViewName: 'claim-compensation-type'
  },
  {
    name: FLOW_STATES.COMPENSATION_MOBILIER,
    entryPointViewName: 'claim-compensation-mobilier'
  },
  {
    name: FLOW_STATES.COMPENSATION_MOBILIER_PROCESSED_OK,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.COMPENSATION_MOBILIER_PROCESSED_KO,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.NEW_CONTACT,
    entryPointViewName: 'claim-closing'
  },
  {
    name: FLOW_STATES.MANUAL_REVIEW,
    entryPointViewName: 'claim-closing'
  }
]
